module.exports = __webpack_public_path__ + "img/icon-title-4.52828e68.png";